import React from 'react';
import {useInView} from 'react-intersection-observer';
import classNames from 'classnames';

const ArrowDown = () => {
  const {ref, inView} = useInView({triggerOnce: true, threshold: 1});
  return <div ref={ref} className={classNames('ArrowDown', inView && 'show')}></div>;
};

export default ArrowDown;
